export default __webpack_public_path__ + "static/media/monitor.725c4f42.png";